import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  stepper: {
    flexDirection: `row`,
  },
  root: {
    width: '100%',
    maxWidth: 1088,
    paddingBottom: theme.spacing(16),
  },
  stepLabel: {
    fontWeight: 300,
    color: '#464A53',
  },
}));
